module.exports = __webpack_public_path__ + "img/143.e17eeb4f.png";